module.exports = __webpack_public_path__ + "static/media/bar-chart.25718e99.svg";